import React from 'react';
import { Card, CardContent } from './ui/card';
import { Upload, Cpu, Download } from 'lucide-react';

const steps = [
  {
    icon: Upload,
    number: '01',
    title: 'Upload SQL Script',
    description: 'Simply upload your database schema SQL file. We support all major SQL dialects including SQL Server, PostgreSQL, and MySQL.'
  },
  {
    icon: Cpu,
    number: '02',
    title: 'AI Processing',
    description: 'Our advanced AI analyzes your schema and generates a complete .NET solution with Clean Architecture structure.'
  },
  {
    icon: Download,
    number: '03',
    title: 'Download & Deploy',
    description: 'Download your completely production-ready and efficiently configured API project with all layers, DTOs, repositories, and services.'
  }
];

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 lg:py-32">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground">
            Three simple steps to transform your database schema into a complete API
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div key={index} className="relative">
                  {/* Connector Line (hidden on mobile) */}
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-border z-0">
                      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-border"></div>
                    </div>
                  )}
                  
                  <Card className="relative z-10 border-2 hover:border-primary/50 transition-all hover:shadow-lg bg-card">
                    <CardContent className="p-8 text-center">
                      {/* Icon Circle */}
                      <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center mx-auto mb-6 shadow-lg">
                        <Icon className="w-8 h-8" />
                      </div>
                      
                      {/* Step Number */}
                      <div className="text-6xl font-bold text-primary/10 mb-2">
                        {step.number}
                      </div>
                      
                      {/* Title */}
                      <h3 className="text-xl font-semibold text-foreground mb-4">
                        {step.title}
                      </h3>
                      
                      {/* Description */}
                      <p className="text-muted-foreground leading-relaxed">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
